import React from "react";
import Layout from "../../Layout";
import { doctorTab } from "../../components/Datas";
import { Link, useParams, useLocation } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import AppointmentsUsed from "../../components/UsedComp/AppointmentsUsed";
import InvoiceUsed from "../../components/UsedComp/InvoiceUsed";
import PaymentsUsed from "../../components/UsedComp/PaymentUsed";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";
import Access from "../../components/Access";
import ChangePassword from "../../components/UsedComp/ChangePassword";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { toast } from "react-hot-toast";

function DoctorProfile() {
  const { id } = useParams();
  const location = useLocation();

  const [activeTab, setActiveTab] = React.useState(1);
  const [doctor, setDoctor] = React.useState(location.state?.doctor || null);
  const [loading, setLoading] = React.useState(!location.state?.doctor);
  const [access, setAccess] = React.useState({});

  React.useEffect(() => {
    if (doctor || !id) return;

    const fetchDoctor = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${BaseUrl}/facility/getAllProfessionalUsers`,
          { withCredentials: true }
        );

        if (res.data?.success && Array.isArray(res.data.data)) {
          const found = res.data.data.find((d) => d._id === id);
          setDoctor(found || null);
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to load doctor data");
      } finally {
        setLoading(false);
      }
    };

    fetchDoctor();
  }, [id, doctor]);

  /* ---------- tab panel ---------- */
  const tabPanel = () => {
    if (!id) {
      return (
        <div className='flex items-center justify-center py-10'>
          <p className='text-textGray'>Invalid doctor ID</p>
        </div>
      );
    }

    switch (activeTab) {
      case 1:
        return <PersonalInfo titles={true} />;
      case 2:
        return <AppointmentsUsed doctor={true} doctorId={id} />;
      case 3:
        return <InvoiceUsed doctorId={id} />;
      case 4:
        return <PaymentsUsed doctor={true} doctorId={id} />;
      case 5:
        return <Access access={access} setAccess={setAccess} />;
      case 6:
        return <ChangePassword />;
      default:
        return null;
    }
  };

  /* ---------- loading / error ---------- */
  if (loading) {
    return (
      <Layout>
        <div className='flex items-center justify-center py-20'>
          <p className='text-textGray'>Loading doctor data...</p>
        </div>
      </Layout>
    );
  }

  if (!doctor && !loading) {
    return (
      <Layout>
        <div className='flex items-center gap-4'>
          <Link
            to='/doctors'
            className='text-md rounded-lg border border-dashed border-subMain bg-white px-4 py-3'
          >
            <IoArrowBackOutline />
          </Link>
        </div>
        <div className='flex items-center justify-center py-20'>
          <p className='text-textGray'>Doctor not found</p>
        </div>
      </Layout>
    );
  }
  const doctorName = doctor?.fullName || "Doctor";
  const doctorEmail = doctor?.emailId || doctor?.user?.email || "";
  const doctorPhone = doctor?.mobileNumber || doctor?.user?.phone || "";

  const doctorImage = doctor?.doctorImage;

  return (
    <Layout>
      {/* header */}
      <div className='flex items-center gap-4'>
        <Link
          to='/doctors'
          className='text-md rounded-lg border border-dashed border-subMain bg-white px-4 py-3'
        >
          <IoArrowBackOutline />
        </Link>
        <h1 className='text-xl font-semibold'>
          {doctor.category === "Doctor" ? "Dr. " : ""}
          {doctorName}
        </h1>
      </div>

      {/* body */}
      <div className='my-8 grid grid-cols-12 items-start gap-6'>
        {/* LEFT PROFILE CARD */}
        <div
          data-aos='fade-right'
          data-aos-duration='1000'
          data-aos-delay='100'
          data-aos-offset='200'
          className='flex-colo top-28 col-span-12 gap-6 rounded-xl border border-border bg-white p-6 lg:sticky lg:col-span-4'
        >
          <div
            className={`${activeTab === 1} cursor-pointer rounded-lg border-dashed border-text p-5 hover:bg-text`}
            onClick={() => setActiveTab(1)}
          >
            <img
              src={
                doctorImage ||
                `https://api.dicebear.com/5.x/initials/svg?seed=${doctorName}`
              }
              alt={doctorName}
              className='h-40 w-40 rounded-full bg-gray-100 object-cover'
              onError={(e) => {
                e.target.src = `https://api.dicebear.com/5.x/initials/svg?seed=${doctorName}`;
              }}
            />

            {/* TEXT */}
            <div className='flex-colo mt-3 gap-2 text-center'>
              <h2 className='text-sm font-semibold'>
                {doctor.category === "Doctor" ? "Dr. " : ""}
                {doctorName}
              </h2>

              {doctorEmail && (
                <p className='text-xs text-textGray'>{doctorEmail}</p>
              )}

              {doctorPhone && <p className='text-xs'>{doctorPhone}</p>}
            </div>
          </div>

          {/* tabs */}
          <div className='flex-colo w-full gap-3 px-2 xl:px-12'>
            {doctorTab.map((tab, index) => (
              <button
                onClick={() => setActiveTab(tab.id)}
                key={index}
                className={`${
                  activeTab === tab.id
                    ? "bg-text text-subMain"
                    : "bg-dry text-main hover:bg-text hover:text-subMain"
                } flex w-full items-center gap-4 rounded p-4 text-xs`}
              >
                <tab.icon className='text-lg' /> {tab.title}
              </button>
            ))}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          data-aos='fade-left'
          data-aos-duration='1000'
          data-aos-delay='100'
          data-aos-offset='200'
          className='col-span-12 rounded-xl border border-border bg-white p-6 lg:col-span-8'
        >
          {tabPanel()}
        </div>
      </div>
    </Layout>
  );
}

export default DoctorProfile;
